import styled from 'styled-components';
import { absFull } from 'helpers/styles.js';

export const ModalContainer = styled.div`
  display: ${props => props.isOpen ? 'block' : 'none'};
  ${absFull()};
  position: fixed;
  text-align: center;
`;

export const ModalBackdrop = styled.div`
${absFull()};
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
`;

export const ModalContent = styled.div`
  border-radius: 20px;
  color: #585858;
  z-index: 21;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
  width: ${({ fullWidth }) => !fullWidth && '90%'};;
  height: 80%;
  max-width: ${({ fullWidth }) => !fullWidth && '1000px'};
  max-height: 600px;
`;

export const ModalClose = styled.a`
  position: absolute;
  top: -34px;
  right: 0;
  bottom: auto;
  left: auto;
  height: 44px;
  line-height: 15px;
  color: white;
  font-size: 23px;
  vertical-align: top;
  text-decoration: none;
  cursor: pointer;
  font-weight: 100;
`;

export const ModalHeader = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
  color: white;
  text-align: center;
  color: #FFFFFF;
  ${absFull('-34px', 0, 'auto', 0)}
`;
